import ChatHeader from './ChatHeader';
import MessageList from './MessageList';
import MessageComposer from './MessageComposer';

export default function ChatThread({
  conversation,
  messages,
  currentUserId,
  otherUserDisplayName,
  otherUserSecondary,
  otherUserPhotoUrl,
  connectionBadgeLabel,
  loadingMessages,
  replyTo,
  onSendMessage,
  onReply,
  onCancelReply,
  onDeleteMessage,
  onEditMessage,
  onSearchInChat,
  onViewProfile,
  onMute,
  onArchive,
  onBlockOrReport,
  onClearChat,
  onBack,
  onAttachmentClick,
  showBackButton,
  isMuted,
  t = (s) => s,
}) {
  const handleSend = (content) => {
    if (replyTo) {
      onSendMessage(content, replyTo);
      onCancelReply?.();
    } else {
      onSendMessage(content);
    }
  };

  return (
    <div className="flex flex-col h-full min-h-0 overflow-hidden bg-gray-50 dark:bg-gray-900/30">
      <ChatHeader
        otherUserDisplayName={otherUserDisplayName}
        otherUserSecondary={otherUserSecondary}
        otherUserPhotoUrl={otherUserPhotoUrl}
        connectionBadgeLabel={connectionBadgeLabel}
        onSearchInChat={onSearchInChat}
        onViewProfile={onViewProfile}
        onMute={onMute}
        onArchive={onArchive}
        onBlockOrReport={onBlockOrReport}
        onClearChat={onClearChat}
        onBack={onBack}
        showBackButton={showBackButton}
        isMuted={isMuted}
        t={t}
      />
      <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
        <MessageList
          messages={messages}
          currentUserId={currentUserId}
          senderDisplayName={otherUserDisplayName}
          loading={loadingMessages}
          onCopy={(text) => text && navigator.clipboard?.writeText(text)}
          onReply={onReply}
          onDelete={onDeleteMessage}
          onEdit={onEditMessage}
          t={t}
        />
      </div>
      <div className="flex-shrink-0 sticky bottom-0 z-10 pb-[env(safe-area-inset-bottom,0px)]">
        <MessageComposer
          onSubmit={handleSend}
          replyPreview={replyTo}
          onCancelReply={onCancelReply}
          disabled={!conversation}
          placeholder={replyTo ? 'Unesite odgovor...' : 'Unesite poruku...'}
          onAttachmentClick={onAttachmentClick}
          t={t}
        />
      </div>
    </div>
  );
}
